import React from 'react';
import { FC } from 'react';

export const TreeADT: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vRvX0Jf0VAfnNCzsaS1RB1cEMJm1J-tdmakk0CZtfVPyuT5pNeLHcFn32fu8ncqs0H6O5YfvEKJGXkl/embed?start=false&loop=false&delayms=60000"
                 width="1200" height="675">
        
                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};